import { ILibrarySectionMatch } from "api/showInfoLibrary/types";

/**
 * The variant the modal opens on: the plain master, with no internal name. Named
 * here rather than left to the order the rows arrive in.
 */
const defaultMatchId = (matches: ILibrarySectionMatch[]): string =>
  (matches.find((match) => !match.internalName) ?? matches[0])?.id ?? "";

export default defaultMatchId;
